$(function () {
	var index = {
		init: function init() {
			this.yuyue()
			this.video()
			this.swiper()
			this.timeLess()
			$('.baoming').click(function () {
				console.log(11)
				var top1 = $('.youhui').offset().top
				$('html,body').animate({
					scrollTop: top1,
				})
			})
		},

		yuyue: function () {
			$('.yuyue').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: ' web雅思节活动报名（百品）',
					},
					{
						search: '?tg',
						name: ' web雅思节活动报名（推广）',
					},
					{
						search: '?360jtppzq',
						name: 'web雅思节活动报名（360）',
					},
					{
						search: '',
						name: 'web雅思节活动报名',
					},
				],
				submitTarget: '.toast_submit_1',
				cityRequired: true,
			})
			new Bselector({
				showSelected: '#toastCity',
				inputSelected: '.toast_city',
				options: [
					{
						text: '北京市',
					},
					{
						text: '天津市',
					},
					{
						text: '上海市',
					},
					{
						text: '重庆市',
					},
					{
						text: '河北省',
					},
					{
						text: '河南省',
					},
					{
						text: '广东省',
					},
					{
						text: '辽宁省',
					},
					{
						text: '湖南省',
					},
					{
						text: '四川省',
					},
					{
						text: '安徽省',
					},
					{
						text: '山东省',
					},
					{
						text: '江苏省',
					},
					{
						text: '浙江省',
					},
					{
						text: '湖北省',
					},
					{
						text: '山西省',
					},
					{
						text: '陕西省',
					},
					{
						text: '福建省',
					},
					{
						text: '江西省',
					},
					{
						text: '广西省',
					},
					{
						text: '甘肃省',
					},
					{
						text: '黑龙江省',
					},
					{
						text: '内蒙古',
					},
					{
						text: '吉林省',
					},
					{
						text: '新疆维吾尔',
					},
					{
						text: '贵州省',
					},
					{
						text: '云南省',
					},
					{
						text: '青海省',
					},
					{
						text: '西藏',
					},
					{
						text: '宁夏回族',
					},
					{
						text: '海南省',
					},
				],
			})
			$('.free').listenForm({
				contentName: [
					{
						search: '?jtppzq',
						name: ' web雅思节领取资料（百品）',
					},
					{
						search: '?tg',
						name: ' web雅思节领取资料（推广）',
					},
					{
						search: '?360jtppzq',
						name: 'web雅思节领取资料（360）',
					},
					{
						search: '',
						name: 'web雅思节领取资料',
					},
				],
				submitTarget: '.free_btn',
				cityRequired: true,
				isMsg: true,
				smsInfo:
					'【新航道】雅思备考资料（电子版）下载地址：https://pan.baidu.com/s/1UvbjPekBpJULLlSHBow7KQ ，提取码：am7u  ',
				successFun: function successFun() {
					$('.alert-bg').show()
				},
			})
			new Bselector({
				showSelected: '#freeCity',
				inputSelected: '.free_city',
				options: [
					{
						text: '北京市',
					},
					{
						text: '天津市',
					},
					{
						text: '上海市',
					},
					{
						text: '重庆市',
					},
					{
						text: '河北省',
					},
					{
						text: '河南省',
					},
					{
						text: '广东省',
					},
					{
						text: '辽宁省',
					},
					{
						text: '湖南省',
					},
					{
						text: '四川省',
					},
					{
						text: '安徽省',
					},
					{
						text: '山东省',
					},
					{
						text: '江苏省',
					},
					{
						text: '浙江省',
					},
					{
						text: '湖北省',
					},
					{
						text: '山西省',
					},
					{
						text: '陕西省',
					},
					{
						text: '福建省',
					},
					{
						text: '江西省',
					},
					{
						text: '广西省',
					},
					{
						text: '甘肃省',
					},
					{
						text: '黑龙江省',
					},
					{
						text: '内蒙古',
					},
					{
						text: '吉林省',
					},
					{
						text: '新疆维吾尔',
					},
					{
						text: '贵州省',
					},
					{
						text: '云南省',
					},
					{
						text: '青海省',
					},
					{
						text: '西藏',
					},
					{
						text: '宁夏回族',
					},
					{
						text: '海南省',
					},
				],
			})
			$('.alert-bg .alert-icon').click(function () {
				$('.alert-bg').hide()
			})
		},
		video: function () {
			TCPlayer('videoPlayerA', {
				fileID: '5285890817617636671',
				appID: '1259605108',
				autoplay: false,
			})
			TCPlayer('videoPlayerB', {
				fileID: '5285890817482472706',
				appID: '1259605108',
				autoplay: false,
			})
		},
		swiper: function () {
			new Swiper('#schoolBox', {
				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
				},
				loop: true,
				pagination: {
					el: '.enventThree_pagination',
					clickable: true,
				},
			})
			new Swiper('#youhui', {
				// autoplay: {
				// 	delay: 3000,
				// 	disableOnInteraction: true,
				// },
				loop: true,
				pagination: {
					el: '.youhui_pagination',
					clickable: true,
				},
			})
			new Swiper('#swiper04', {
				autoplay: true,
				slidesPerView: 3,
				loop: true,
			})
		},
		timeLess: function timeLess() {
			function show_time() {
				var time_start = new Date().getTime()
				var time_end = new Date('2021/5/11 10:00:00').getTime()

				var time_distance = time_end - time_start

				if (time_distance > 0) {
					var int_day = Math.floor(time_distance / 86400000)
					time_distance -= int_day * 86400000

					var int_hour = Math.floor(time_distance / 3600000)
					time_distance -= int_hour * 3600000

					var int_minute = Math.floor(time_distance / 60000)
					time_distance -= int_minute * 60000
					var int_second = Math.floor(time_distance / 1000)

					if (int_day < 10) {
						int_day = '0' + int_day
					}

					if (int_hour < 10) {
						int_hour = '0' + int_hour
					}

					if (int_minute < 10) {
						int_minute = '0' + int_minute
					}

					if (int_second < 10) {
						int_second = '0' + int_second
					}

					$('#time_d').val(int_day)
					$('#time_h').val(int_hour)
					$('#time_m').val(int_minute)
					$('#time_s').val(int_second)
				} else {
					$('#time_d').val('00')
					$('#time_h').val('00')
					$('#time_m').val('00')
					$('#time_s').val('00')
					window.clearInterval(interval)
				}
			}

			var interval = setInterval(show_time, 1000)
		},
	}
	index.init()
})
